export default {
    allowedRoutes: [
        'global:login',
        'global:universe-switcher'
    ],
    symbols: {
        GBP: '£',
        EUR: '€',
        XTS: 'X',
        CAD: 'C$',
        NZD: 'NZ$',
        BTC: '₿'
    },
    defaultCountry: 'GB',
    topCountries: [
        {id: 'GB', name: 'United Kingdom' },
        {id: 'IE', name: 'Ireland' }
    ],
    topdopplernegro: [
        {id: 'ME', name: 'dopplernegro' },
    ],
    countries: [
        { id: '', name: 'None' },
        {id: 'AF', name: 'Afghanistan' },
        {id: 'AX', name: 'Åland Islands'},
        {id: 'AL', name: 'Albania' },
        {id: 'DZ', name: 'Algeria' },
        {id: 'AS', name: 'American Samoa' },
        {id: 'AD', name: 'Andorra' },
        {id: 'AO', name: 'Angola' },
        {id: 'AI', name: 'Anguilla' },
        {id: 'AQ', name: 'Antarctica' },
        {id: 'AG', name: 'Antigua and Barbuda' },
        {id: 'AR', name: 'Argentina' },
        {id: 'AM', name: 'Armenia' },
        {id: 'AW', name: 'Aruba' },
        {id: 'AU', name: 'Australia' },
        {id: 'AT', name: 'Austria' },
        {id: 'AZ', name: 'Azerbaijan' },
        {id: 'BS', name: 'Bahamas' },
        {id: 'BH', name: 'Bahrain' },
        {id: 'BD', name: 'Bangladesh' },
        {id: 'BB', name: 'Barbados' },
        {id: 'BY', name: 'Belarus' },
        {id: 'BE', name: 'Belgium' },
        {id: 'BZ', name: 'Belize' },
        {id: 'BJ', name: 'Benin' },
        {id: 'BM', name: 'Bermuda' },
        {id: 'BT', name: 'Bhutan' },
        {id: 'BO', name: 'Bolivia' },
        {id: 'BQ', name: 'Bonaire, Sint Eustatius and Saba' },
        {id: 'BA', name: 'Bosnia and Herzegovina' },
        {id: 'BW', name: 'Botswana' },
        {id: 'BV', name: 'Bouvet Island' },
        {id: 'BR', name: 'Brazil' },
        {id: 'IO', name: 'British Indian Ocean Territory' },
        {id: 'BN', name: 'Brunei Darussalam' },
        {id: 'BG', name: 'Bulgaria' },
        {id: 'BF', name: 'Burkina Faso' },
        {id: 'BI', name: 'Burundi' },
        {id: 'KH', name: 'Cambodia' },
        {id: 'CM', name: 'Cameroon' },
        {id: 'CA', name: 'Canada' },
        {id: 'CV', name: 'Cape Verde' },
        {id: 'KY', name: 'Cayman Islands' },
        {id: 'CF', name: 'Central African Republic' },
        {id: 'TD', name: 'Chad' },
        {id: 'CL', name: 'Chile' },
        {id: 'CN', name: 'China' },
        {id: 'CX', name: 'Christmas Island' },
        {id: 'MO', name: 'Cocos (Keeling) Islands' },
        {id: 'CO', name: 'Colombia' },
        {id: 'KM', name: 'Comoros' },
        {id: 'CG', name: 'Congo' },
        {id: 'CD', name: 'Congo, the Democratic Republic of the' },
        {id: 'CK', name: 'Cook Islands' },
        {id: 'CR', name: 'Costa Rica' },
        {id: 'CI', name: 'Côte d Ivoire' },
        {id: 'HR', name: 'Croatia' },
        {id: 'CU', name: 'Cuba' },
        {id: 'CW', name: 'Cura' },
        {id: 'CY', name: 'Cyprus' },
        {id: 'CZ', name: 'Czech Republic' },
        {id: 'DK', name: 'Denmark' },
        {id: 'DJ', name: 'Djibouti' },
        {id: 'DM', name: 'Dominica' },
        {id: 'DO', name: 'Dominican Republic' },
        {id: 'EC', name: 'Ecuador' },
        {id: 'EG', name: 'Egypt' },
        {id: 'SV', name: 'El Salvador' },
        {id: 'GQ', name: 'Equatorial Guinea' },
        {id: 'ER', name: 'Eritrea' },
        {id: 'EE', name: 'Estonia' },
        {id: 'ET', name: 'Ethiopia' },
        {id: 'FK', name: 'Falkland Islands (Malvinas)' },
        {id: 'FO', name: 'Faroe Islands' },
        {id: 'FJ', name: 'Fiji' },
        {id: 'FI', name: 'Finland' },
        {id: 'FR', name: 'France' },
        {id: 'GF', name: 'French Guiana' },
        {id: 'PF', name: 'French Polynesia' },
        {id: 'TF', name: 'French Southern Territories' },
        {id: 'GA', name: 'Gabon' },
        {id: 'GM', name: 'Gambia' },
        {id: 'GE', name: 'Georgia' },
        {id: 'DE', name: 'Germany' },
        {id: 'GH', name: 'Ghana' },
        {id: 'GI', name: 'Gibraltar' },
        {id: 'GR', name: 'Greece' },
        {id: 'GL', name: 'Greenland' },
        {id: 'GD', name: 'Grenada' },
        {id: 'GP', name: 'Guadeloupe' },
        {id: 'GU', name: 'Guam' },
        {id: 'GT', name: 'Guatemala' },
        {id: 'GG', name: 'Guernsey' },
        {id: 'GN', name: 'Guinea' },
        {id: 'GW', name: 'Guinea-Bissau' },
        {id: 'GY', name: 'Guyana' },
        {id: 'HT', name: 'Haiti' },
        {id: 'HM', name: 'Heard Island and McDonald Islands' },
        {id: 'VA', name: 'Holy See (Vatican City State)' },
        {id: 'HN', name: 'Honduras' },
        {id: 'HK', name: 'Hong Kong' },
        {id: 'HU', name: 'Hungary' },
        {id: 'IS', name: 'Iceland' },
        {id: 'IN', name: 'India' },
        {id: 'ID', name: 'Indonesia' },
        {id: 'IR', name: 'Iran, Islamic Republic of' },
        {id: 'IQ', name: 'Iraq' },
        {id: 'IE', name: 'Ireland' },
        {id: 'IM', name: 'Isle of Man' },
        {id: 'IL', name: 'Israel' },
        {id: 'IT', name: 'Italy' },
        {id: 'JM', name: 'Jamaica' },
        {id: 'JP', name: 'Japan' },
        {id: 'JE', name: 'Jersey' },
        {id: 'JO', name: 'Jordan' },
        {id: 'KZ', name: 'Kazakhstan' },
        {id: 'KE', name: 'Kenya' },
        {id: 'KI', name: 'Kiribati' },
        {id: 'KP', name: 'Korea, Democratic People s Republic of' },
        {id: 'KR', name: 'Korea, Republic of' },
        {id: 'KW', name: 'Kuwait' },
        {id: 'KG', name: 'Kyrgyzstan' },
        {id: 'LA', name: 'Lao People s Democratic Republic' },
        {id: 'LV', name: 'Latvia' },
        {id: 'LB', name: 'Lebanon' },
        {id: 'LS', name: 'Lesotho' },
        {id: 'LR', name: 'Liberia' },
        {id: 'LY', name: 'Libya' },
        {id: 'LI', name: 'Liechtenstein' },
        {id: 'LT', name: 'Lithuania' },
        {id: 'LU', name: 'Luxembourg' },
        {id: 'MK', name: 'Macedonia, The Former Yugoslav Republic of' },
        {id: 'MG', name: 'Madagascar' },
        {id: 'MW', name: 'Malawi' },
        {id: 'MY', name: 'Malaysia' },
        {id: 'MV', name: 'Maldives' },
        {id: 'ML', name: 'Mali' },
        {id: 'MT', name: 'Malta' },
        {id: 'MH', name: 'Marshall Islands' },
        {id: 'MQ', name: 'Martinique' },
        {id: 'MR', name: 'Mauritania' },
        {id: 'MU', name: 'Mauritius' },
        {id: 'YT', name: 'Mayotte' },
        {id: 'MX', name: 'Mexico' },
        {id: 'FM', name: 'Micronesia, Federated States of' },
        {id: 'MD', name: 'Moldova, Republic of' },
        {id: 'MC', name: 'Monaco' },
        {id: 'MN', name: 'Mongolia' },
        {id: 'ME', name: 'dopplernegro' },
        {id: 'MS', name: 'Montserrat' },
        {id: 'MA', name: 'Morocco' },
        {id: 'MZ', name: 'Mozambique' },
        {id: 'MM', name: 'Myanmar' },
        {id: 'NA', name: 'Namibia' },
        {id: 'NR', name: 'Nauru' },
        {id: 'NP', name: 'Nepal' },
        {id: 'NL', name: 'Netherlands' },
        {id: 'NC', name: 'New Caledonia' },
        {id: 'NZ', name: 'New Zealand' },
        {id: 'NI', name: 'Nicaragua' },
        {id: 'NE', name: 'Niger' },
        {id: 'NG', name: 'Nigeria' },
        {id: 'NU', name: 'Niue' },
        {id: 'NF', name: 'Norfolk Island' },
        {id: 'MP', name: 'Northern Mariana Islands' },
        {id: 'NO', name: 'Norway' },
        {id: 'OM', name: 'Oman' },
        {id: 'PK', name: 'Pakistan' },
        {id: 'PW', name: 'Palau' },
        {id: 'PS', name: 'Palestinian Territory, Occupied' },
        {id: 'PA', name: 'Panama' },
        {id: 'PG', name: 'Papua New Guinea' },
        {id: 'PY', name: 'Paraguay' },
        {id: 'PE', name: 'Peru' },
        {id: 'PH', name: 'Philippines' },
        {id: 'PN', name: 'Pitcairn' },
        {id: 'PL', name: 'Poland' },
        {id: 'PT', name: 'Portugal' },
        {id: 'PR', name: 'Puerto Rico' },
        {id: 'QA', name: 'Qatar' },
        {id: 'RE', name: 'Réunion' },
        {id: 'RO', name: 'Romania' },
        {id: 'RU', name: 'Russia' },
        {id: 'RW', name: 'Rwanda' },
        {id: 'SA', name: 'Saba' },
        {id: 'BL', name: 'Saint Barthélemy' },
        {id: 'SH', name: 'Saint Helena' },
        {id: 'KN', name: 'Saint Kitts and Nevis' },
        {id: 'LC', name: 'Saint Lucia' },
        {id: 'MF', name: 'Saint Martin' },
        {id: 'PM', name: 'Saint Pierre and Miquelon' },
        {id: 'VC', name: 'Saint Vincent and the Grenadines' },
        {id: 'WS', name: 'Samoa' },
        {id: 'SM', name: 'San Marino' },
        {id: 'ST', name: 'Sao Tome and Principe' },
        {id: 'SN', name: 'Senegal' },
        {id: 'RS', name: 'Serbia' },
        {id: 'SC', name: 'Seychelles' },
        {id: 'SL', name: 'Sierra Leone' },
        {id: 'SG', name: 'Singapore' },
        {id: 'SX', name: 'Sint Maarten (Dutch part)' },
        {id: 'SK', name: 'Slovakia' },
        {id: 'SI', name: 'Slovenia' },
        {id: 'SB', name: 'Solomon Islands' },
        {id: 'SO', name: 'Somalia' },
        {id: 'ZA', name: 'South Africa' },
        {id: 'GS', name: 'South Georgia and the South Sandwich Islands' },
        {id: 'SS', name: 'South Sudan' },
        {id: 'ES', name: 'Spain' },
        {id: 'LK', name: 'Sri Lanka' },
        {id: 'SD', name: 'Sudan' },
        {id: 'SR', name: 'Suriname' },
        {id: 'SJ', name: 'Svalbard and Jan Mayen' },
        {id: 'SZ', name: 'Swaziland' },
        {id: 'SE', name: 'Sweden' },
        {id: 'CH', name: 'Switzerland' },
        {id: 'SY', name: 'Syrian Arab Republic' },
        {id: 'TW', name: 'Taiwan, Province of China' },
        {id: 'TJ', name: 'Tajikistan' },
        {id: 'TZ', name: 'Tanzania, United Republic of' },
        {id: 'TH', name: 'Thailand' },
        {id: 'TL', name: 'Timor-Leste' },
        {id: 'TG', name: 'Togo' },
        {id: 'TK', name: 'Tokelau' },
        {id: 'TO', name: 'Tonga' },
        {id: 'TT', name: 'Trinidad and Tobago' },
        {id: 'TN', name: 'Tunisia' },
        {id: 'TR', name: 'Turkey' },
        {id: 'TM', name: 'Turkmenistan' },
        {id: 'TC', name: 'Turks and Caicos Islands' },
        {id: 'TV', name: 'Tuvalu' },
        {id: 'UG', name: 'Uganda' },
        {id: 'UA', name: 'Ukraine' },
        {id: 'AE', name: 'United Arab Emirates' },
        {id: 'GB', name: 'United Kingdom' },
        {id: 'US', name: 'United States' },
        {id: 'UM', name: 'United States Minor Outlying Islands' },
        {id: 'UY', name: 'Uruguay' },
        {id: 'UZ', name: 'Uzbekistan' },
        {id: 'VU', name: 'Vanuatu' },
        {id: 'VE', name: 'Venezuela' },
        {id: 'VN', name: 'Viet Nam' },
        {id: 'VG', name: 'Virgin Islands, British' },
        {id: 'VI', name: 'Virgin Islands, U.S.' },
        {id: 'WF', name: 'Wallis and Futuna' },
        {id: 'EH', name: 'Western Sahara' },
        {id: 'YE', name: 'Yemen' },
        {id: 'ZM', name: 'Zambia' },
        {id: 'ZW', name: 'Zimbabwe' }

    ],
    mobilePrefixes: [
        {prefix: '', id: 'None'},
        { prefix: '93', id: 'AF' },
        { prefix: '242', id: 'CG' },
        { prefix: '44', id: 'GB' },
        { prefix: '355', id: 'AL' },
        { prefix: '376', id: 'AD' },
        { prefix: '1-264', id: 'AI' },
        { prefix: '672', id: 'AQ' },
        { prefix: '1-268', id: 'AG' },
        { prefix: '54', id: 'AR' },
        { prefix: '374', id: 'AM' },
        { prefix: '297', id: 'AW' },
        { prefix: '994', id: 'AZ' },
        { prefix: '1-242', id: 'BS' },
        { prefix: '973', id: 'BH' },
        { prefix: '1-246', id: 'BB' },
        { prefix: '375', id: 'BY' },
        { prefix: '229', id: 'BJ' },
        { prefix: '1-441', id: 'BM' },
        { prefix: '975', id: 'BT' },
        { prefix: '591', id: 'BO' },
        { prefix: '599', id: 'BQ' },
        { prefix: '387', id: 'BA' },
        { prefix: '267', id: 'BW' },
        { prefix: '47', id: 'BV' },
        { prefix: '246', id: 'IO' },
        { prefix: '673', id: 'BN' },
        { prefix: '359', id: 'BG' },
        { prefix: '226', id: 'BF' },
        { prefix: '257', id: 'BI' },
        { prefix: '237', id: 'CM' },
        { prefix: '238', id: 'CV' },
        { prefix: '1-345', id: 'KY' },
        { prefix: '56', id: 'CL' },
        { prefix: '57', id: 'CO' },
        { prefix: '269', id: 'KM' },
        { prefix: '682', id: 'CK' },
        { prefix: '506', id: 'CR' },
        { prefix: '385', id: 'HR' },
        { prefix: '53', id: 'CU' },
        { prefix: '599', id: 'CW' },
        { prefix: '225', id: 'CI' },
        { prefix: '1-767', id: 'DM' },
        { prefix: '1-809', id: 'DO' },
        { prefix: '1-829', id: 'DO' },
        { prefix: '1-849', id: 'DO' },
        { prefix: '20', id: 'EG' },
        { prefix: '503', id: 'SV' },
        { prefix: '291', id: 'ER' },
        { prefix: '372', id: 'EE' },
        { prefix: '500', id: 'FK' },
        { prefix: '298', id: 'FO' },
        { prefix: '679', id: 'FJ' },
        { prefix: '241', id: 'GA' },
        { prefix: '220', id: 'GM' },
        { prefix: '995', id: 'GE' },
        { prefix: '233', id: 'GH' },
        { prefix: '350', id: 'GI' },
        { prefix: '1-473', id: 'GD' },
        { prefix: '502', id: 'GT' },
        { prefix: '44', id: 'GG' },
        { prefix: '224', id: 'GN' },
        { prefix: '592', id: 'GY' },
        { prefix: '672', id: 'HM' },
        { prefix: '379', id: 'VA' },
        { prefix: '504', id: 'HN' },
        { prefix: '354', id: 'IS' },
        { prefix: '964', id: 'IQ' },
        { prefix: '353', id: 'IE' },
        { prefix: '44-1624', id: 'IM' },
        { prefix: '39', id: 'IT' },
        { prefix: '1-876', id: 'JM' },
        { prefix: '44-1534', id: 'JE' },
        { prefix: '962', id: 'JO' },
        { prefix: '7', id: 'KZ' },
        { prefix: '254', id: 'KE' },
        { prefix: '686', id: 'KI' },
        { prefix: '965', id: 'KW' },
        { prefix: '996', id: 'KG' },
        { prefix: '856', id: 'LA' },
        { prefix: '961', id: 'LB' },
        { prefix: '266', id: 'LS' },
        { prefix: '231', id: 'LR' },
        { prefix: '423', id: 'LI' },
        { prefix: '370', id: 'LT' },
        { prefix: '352', id: 'LU' },
        { prefix: '853', id: 'MO' },
        { prefix: '389', id: 'MK' },
        { prefix: '261', id: 'MG' },
        { prefix: '265', id: 'MW' },
        { prefix: '960', id: 'MV' },
        { prefix: '356', id: 'MT' },
        { prefix: '692', id: 'MH' },
        { prefix: '222', id: 'MR' },
        { prefix: '230', id: 'MU' },
        { prefix: '52', id: 'MX' },
        { prefix: '691', id: 'FM' },
        { prefix: '373', id: 'MD' },
        { prefix: '377', id: 'MC' },
        { prefix: '976', id: 'MN' },
        { prefix: '382', id: 'ME' },
        { prefix: '1-664', id: 'MS' },
        { prefix: '212', id: 'MA' },
        { prefix: '258', id: 'MZ' },
        { prefix: '264', id: 'NA' },
        { prefix: '674', id: 'NR' },
        { prefix: '977', id: 'NP' },
        { prefix: '31', id: 'NL' },
        { prefix: '64', id: 'NZ' },
        { prefix: '505', id: 'NI' },
        { prefix: '227', id: 'NE' },
        { prefix: '234', id: 'NG' },
        { prefix: '683', id: 'NU' },
        { prefix: '47', id: 'NO' },
        { prefix: '968', id: 'OM' },
        { prefix: '680', id: 'PW' },
        { prefix: '970', id: 'PS' },
        { prefix: '507', id: 'PA' },
        { prefix: '675', id: 'PG' },
        { prefix: '595', id: 'PY' },
        { prefix: '51', id: 'PE' },
        { prefix: '64', id: 'PN' },
        { prefix: '974', id: 'QA' },
        { prefix: '40', id: 'RO' },
        { prefix: '590', id: 'BL' },
        { prefix: '290', id: 'SH' },
        { prefix: '247', id: 'SH' },
        { prefix: '1-869', id: 'KN' },
        { prefix: '1-758', id: 'LC' },
        { prefix: '590', id: 'MF' },
        { prefix: '1-784', id: 'VC' },
        { prefix: '685', id: 'WS' },
        { prefix: '378', id: 'SM' },
        { prefix: '239', id: 'ST' },
        { prefix: '966', id: 'SA' },
        { prefix: '221', id: 'SN' },
        { prefix: '248', id: 'SC' },
        { prefix: '232', id: 'SL' },
        { prefix: '1-721', id: 'SX' },
        { prefix: '386', id: 'SI' },
        { prefix: '677', id: 'SB' },
        { prefix: '27', id: 'ZA' },
        { prefix: '500', id: 'GS' },
        { prefix: '34', id: 'ES' },
        { prefix: '94', id: 'LK' },
        { prefix: '597', id: 'SR' },
        { prefix: '47', id: 'SJ' },
        { prefix: '268', id: 'SZ' },
        { prefix: '886', id: 'TW' },
        { prefix: '992', id: 'TJ' },
        { prefix: '255', id: 'TZ' },
        { prefix: '66', id: 'TH' },
        { prefix: '670', id: 'TL' },
        { prefix: '228', id: 'TG' },
        { prefix: '690', id: 'TK' },
        { prefix: '676', id: 'TO' },
        { prefix: '1-868', id: 'TT' },
        { prefix: '216', id: 'TN' },
        { prefix: '1-649', id: 'TC' },
        { prefix: '688', id: 'TV' },
        { prefix: '256', id: 'UG' },
        { prefix: '598', id: 'UY' },
        { prefix: '678', id: 'VU' },
        { prefix: '58', id: 'VE' },
        { prefix: '1-284', id: 'VG' },
        { prefix: '212', id: 'EH' },
        { prefix: '260', id: 'ZM' },
        { prefix: '358', id: 'AX' },
        { prefix: '213', id: 'DZ' },
        { prefix: '1-684', id: 'AS' },
        { prefix: '244', id: 'AO' },
        { prefix: '61', id: 'AU' },
        { prefix: '43', id: 'AT' },
        { prefix: '880', id: 'BD' },
        { prefix: '32', id: 'BE' },
        { prefix: '501', id: 'BZ' },
        { prefix: '55', id: 'BR' },
        { prefix: '855', id: 'KH' },
        { prefix: '1', id: 'CA' },
        { prefix: '236', id: 'CF' },
        { prefix: '235', id: 'TD' },
        { prefix: '86', id: 'CN' },
        { prefix: '61', id: 'CX' },
        { prefix: '61', id: 'CC' },
        { prefix: '243', id: 'CD' },
        { prefix: '257', id: 'CY' },
        { prefix: '420', id: 'CZ' },
        { prefix: '45', id: 'DK' },
        { prefix: '253', id: 'DJ' },
        { prefix: '593', id: 'EC' },
        { prefix: '240', id: 'GQ' },
        { prefix: '251', id: 'ET' },
        { prefix: '358', id: 'FI' },
        { prefix: '33', id: 'FR' },
        { prefix: '594', id: 'GF' },
        { prefix: '689', id: 'PF' },
        { prefix: '262', id: 'TF' },
        { prefix: '49', id: 'DE' },
        { prefix: '30', id: 'GR' },
        { prefix: '299', id: 'GL' },
        { prefix: '590', id: 'GP' },
        { prefix: '1-671', id: 'GU' },
        { prefix: '245', id: 'GW' },
        { prefix: '509', id: 'HT' },
        { prefix: '852', id: 'HK' },
        { prefix: '36', id: 'HU' },
        { prefix: '91', id: 'IN' },
        { prefix: '62', id: 'ID' },
        { prefix: '98', id: 'IR' },
        { prefix: '972', id: 'IL' },
        { prefix: '81', id: 'JP' },
        { prefix: '850', id: 'KP' },
        { prefix: '82', id: 'KR' },
        { prefix: '371', id: 'LV' },
        { prefix: '218', id: 'LY' },
        { prefix: '60', id: 'MY' },
        { prefix: '223', id: 'ML' },
        { prefix: '596', id: 'MQ' },
        { prefix: '262', id: 'YT' },
        { prefix: '95', id: 'MM' },
        { prefix: '672', id: 'NF' },
        { prefix: '1-670', id: 'MP' },
        { prefix: '92', id: 'PK' },
        { prefix: '63', id: 'PH' },
        { prefix: '48', id: 'PL' },
        { prefix: '351', id: 'PT' },
        { prefix: '1-787', id: 'PR' },
        { prefix: '1-939', id: 'PR' },
        { prefix: '262', id: 'RE' },
        { prefix: '7', id: 'RU' },
        { prefix: '250', id: 'RW' },
        { prefix: '508', id: 'PM' },
        { prefix: '381', id: 'RS' },
        { prefix: '65', id: 'SG' },
        { prefix: '421', id: 'SK' },
        { prefix: '252', id: 'SO' },
        { prefix: '211', id: 'SS' },
        { prefix: '249', id: 'SD' },
        { prefix: '46', id: 'SE' },
        { prefix: '41', id: 'CH' },
        { prefix: '963', id: 'SY' },
        { prefix: '90', id: 'TR' },
        { prefix: '993', id: 'TM' },
        { prefix: '380', id: 'UA' },
        { prefix: '971', id: 'AE' },
        { prefix: '1', id: 'US' },
        { prefix: '1', id: 'UM' },
        { prefix: '998', id: 'UZ' },
        { prefix: '84', id: 'VN' },
        { prefix: '1-340', id: 'VI' },
        { prefix: '681', id: 'WF' },
        { prefix: '967', id: 'YE' },
        { prefix: '263', id: 'ZW' }
    ],
    eligibleBetTypes: [
        {id: 'SGL', name: 'Single' },
        {id: 'DBL', name: 'Double' },
        {id: 'TBL', name: 'Treble' },
        {id: '2F3', name: 'Doubles from 3' },
        {id: 'TRX', name: 'Trixie' },
        {id: 'PAT', name: 'Patent' },
        {id: '4F', name: '4 fold' },
        {id: '2F4', name: 'Doubles from 4' },
        {id: '3F4', name: 'Trebles from 4' },
        {id: 'YAN', name: 'Yankee' },
        {id: 'L15', name: 'Lucky 15' },
        {id: '5F', name: '5 fold' },
        {id: '2F5', name: 'Doubles from 5' },
        {id: '3F5', name: 'Trebles from 5' },
        {id: '4F5', name: '4 folds from 5' },
        {id: 'CAN', name: 'Canadian' },
        {id: 'L31', name: 'Lucky 31' },
        {id: '6F', name: '6 fold' },
        {id: '2F6', name: 'Doubles from 6' },
        {id: '3F6', name: 'Trebles from 6' },
        {id: '4F6', name: '4 folds from 6' },
        {id: '5F6', name: '5 folds from 6' },
        {id: 'HNZ', name: 'Heinz' },
        {id: 'L63', name: 'Lucky 63' },
        {id: '7F', name: '7 fold' },
        {id: '2F7', name: 'Doubles from 7' },
        {id: '3F7', name: 'Trebles from 7' },
        {id: '4F7', name: '4 folds from 7' },
        {id: '5F7', name: '5 folds from 7' },
        {id: '6F7', name: '6 folds from 7' },
        {id: 'SHNZ', name: 'Super Heinz' },
        {id: '8F', name: '8 fold' },
        {id: '2F8', name: 'Doubles from 8' },
        {id: '3F8', name: 'Trebles from 8' },
        {id: '4F8', name: '4 folds from 8' },
        {id: '5F8', name: '5 folds from 8' },
        {id: '6F8', name: '6 folds from 8' },
        {id: '7F8', name: '7 folds from 8' },
        {id: 'GOL', name: 'Goliath' },
        {id: '9F', name: '9 fold' },
        {id: '2F9', name: 'Doubles from 9' },
        {id: '3F9', name: 'Trebles from 9' },
        {id: '8F9', name: '8 folds from 9' },
        {id: '10F', name: '10 fold' },
        {id: '2F10', name: 'Doubles from 10' },
        {id: '3F10', name: 'Trebles from 10' },
        {id: '9F10', name: '9 folds from 10' },
        {id: '11F', name: '11 fold' },
        {id: '2F11', name: 'Doubles from 11' },
        {id: '3F11', name: 'Trebles from 11' },
        {id: '10F11', name: '10 folds from 11' },
        {id: '12F', name: '12 fold' },
        {id: '2F12', name: 'Doubles from 12' },
        {id: '3F12', name: 'Trebles from 12' },
        {id: '11F12', name: '11 folds from 12' },
        {id: '13F', name: '13 fold' },
        {id: '2F13', name: 'Doubles from 13' },
        {id: '3F13', name: 'Trebles from 13' },
        {id: '12F13', name: '12 folds from 13' },
        {id: '14F', name: '14 fold' },
        {id: '2F14', name: 'Doubles from 14' },
        {id: '3F14', name: 'Trebles from 14' },
        {id: '13F14', name: '13 folds from 14' },
        {id: '15F', name: '15 fold' },
        {id: '2F15', name: 'Doubles from 15' },
        {id: '3F15', name: 'Trebles from 15' },
        {id: '14F15', name: '14 folds from 15' },
        {id: '16F', name: '16 fold' },
        {id: '2F16', name: 'Doubles from 16' },
        {id: '3F16', name: 'Trebles from 16' },
        {id: '15F16', name: '15 folds from 16' },
        {id: '17F', name: '17 fold' },
        {id: '2F17', name: 'Doubles from 17' },
        {id: '3F17', name: 'Trebles from 17' },
        {id: '16F17', name: '16 folds from 17' },
        {id: '18F', name: '18 fold' },
        {id: '2F18', name: 'Doubles from 18' },
        {id: '3F18', name: 'Trebles from 18' },
        {id: '17F18', name: '17 folds from 18' },
        {id: '19F', name: '19 fold' },
        {id: '2F19', name: 'Doubles from 19' },
        {id: '3F19', name: 'Trebles from 19' },
        {id: '18F19', name: '18 folds from 19' },
        {id: '20F', name: '20 fold' },
        {id: '2F20', name: 'Doubles from 20' },
        {id: '3F20', name: 'Trebles from 20' },
        {id: '19F20', name: '19 folds from 20' }

    ],
    priceOptions: [
        {d: 1001, f: '1000/1', fractionalNumerator: 1000, fractionalDenominator: 1},
        {d: 501, f: '500/1', fractionalNumerator: 500, fractionalDenominator: 1},
        {d: 301, f: '300/1', fractionalNumerator: 300, fractionalDenominator: 1},
        {d: 251, f: '250/1', fractionalNumerator: 250, fractionalDenominator: 1},
        {d: 201, f: '200/1', fractionalNumerator: 200, fractionalDenominator: 1},
        {d: 151, f: '150/1', fractionalNumerator: 150, fractionalDenominator: 1},
        {d: 126, f: '125/1', fractionalNumerator: 125, fractionalDenominator: 1},
        {d: 101, f: '100/1', fractionalNumerator: 100, fractionalDenominator: 1},
        {d: 81, f: '80/1', fractionalNumerator: 80, fractionalDenominator: 1},
        {d: 67, f: '66/1', fractionalNumerator: 66, fractionalDenominator: 1},
        {d: 56, f: '55/1', fractionalNumerator: 55, fractionalDenominator: 1},
        {d: 51, f: '50/1', fractionalNumerator: 50, fractionalDenominator: 1},
        {d: 41, f: '40/1', fractionalNumerator: 40, fractionalDenominator: 1},
        {d: 34, f: '33/1', fractionalNumerator: 33, fractionalDenominator: 1},
        {d: 29, f: '28/1', fractionalNumerator: 28, fractionalDenominator: 1},
        {d: 26, f: '25/1', fractionalNumerator: 25, fractionalDenominator: 1},
        {d: 23, f: '22/1', fractionalNumerator: 22, fractionalDenominator: 1},
        {d: 21, f: '20/1', fractionalNumerator: 20, fractionalDenominator: 1},
        {d: 19, f: '18/1', fractionalNumerator: 18, fractionalDenominator: 1},
        {d: 17, f: '16/1', fractionalNumerator: 16, fractionalDenominator: 1},
        {d: 16, f: '15/1', fractionalNumerator: 15, fractionalDenominator: 1},
        {d: 15, f: '14/1', fractionalNumerator: 14, fractionalDenominator: 1},
        {d: 14, f: '13/1', fractionalNumerator: 13, fractionalDenominator: 1},
        {d: 13, f: '12/1', fractionalNumerator: 12, fractionalDenominator: 1},
        {d: 12, f: '11/1', fractionalNumerator: 11, fractionalDenominator: 1},
        {d: 11, f: '10/1', fractionalNumerator: 10, fractionalDenominator: 1},
        {d: 10, f: '9/1', fractionalNumerator: 9, fractionalDenominator: 1},
        {d: 9, f: '8/1', fractionalNumerator: 8, fractionalDenominator: 1},
        {d: 8.5, f: '15/2', fractionalNumerator: 15, fractionalDenominator: 2},
        {d: 8, f: '7/1', fractionalNumerator: 7, fractionalDenominator: 1},
        {d: 7.5, f: '13/2', fractionalNumerator: 13, fractionalDenominator: 2},
        {d: 7, f: '6/1', fractionalNumerator: 6, fractionalDenominator: 1},
        {d: 6.5, f: '11/2', fractionalNumerator: 11, fractionalDenominator: 2},
        {d: 6, f: '5/1', fractionalNumerator: 5, fractionalDenominator: 1},
        {d: 5.5, f: '9/2', fractionalNumerator: 9, fractionalDenominator: 2},
        {d: 5, f: '4/1', fractionalNumerator: 4, fractionalDenominator: 1},
        {d: 4.9, f: '39/10', fractionalNumerator: 39, fractionalDenominator: 10},
        {d: 4.8, f: '19/5', fractionalNumerator: 19, fractionalDenominator: 5},
        {d: 4.75, f: '15/4', fractionalNumerator: 15, fractionalDenominator: 4},
        {d: 4.6, f: '18/5', fractionalNumerator: 18, fractionalDenominator: 5},
        {d: 4.5, f: '7/2', fractionalNumerator: 7, fractionalDenominator: 2},
        {d: 4.4, f: '17/5', fractionalNumerator: 17, fractionalDenominator: 5},
        {d: 4.3, f: '33/10', fractionalNumerator: 33, fractionalDenominator: 10},
        {d: 4.25, f: '13/4', fractionalNumerator: 13, fractionalDenominator: 4},
        {d: 4.2, f: '16/5', fractionalNumerator: 16, fractionalDenominator: 5},
        {d: 4.1, f: '31/10', fractionalNumerator: 31, fractionalDenominator: 10},
        {d: 4, f: '3/1', fractionalNumerator: 3, fractionalDenominator: 1},
        {d: 3.8, f: '14/5', fractionalNumerator: 14, fractionalDenominator: 8},
        {d: 3.75, f: '11/4', fractionalNumerator: 11, fractionalDenominator: 4},
        {d: 3.7, f: '27/10', fractionalNumerator: 27, fractionalDenominator: 10},
        {d: 3.6, f: '13/5', fractionalNumerator: 13, fractionalDenominator: 5},
        {d: 3.5, f: '5/2', fractionalNumerator: 5, fractionalDenominator: 2},
        {d: 3.4, f: '12/5', fractionalNumerator: 12, fractionalDenominator: 5},
        {d: 3.3, f: '23/10', fractionalNumerator: 23, fractionalDenominator: 10},
        {d: 3.25, f: '9/4', fractionalNumerator: 9, fractionalDenominator: 4},
        {d: 3.2, f: '11/5', fractionalNumerator: 11, fractionalDenominator: 5},
        {d: 3.1, f: '21/10', fractionalNumerator: 21, fractionalDenominator: 10},
        {d: 3, f: '2/1', fractionalNumerator: 2, fractionalDenominator: 1},
        {d: 2.87, f: '15/8', fractionalNumerator: 15, fractionalDenominator: 8},
        {d: 2.8, f: '9/5', fractionalNumerator: 9, fractionalDenominator: 5},
        {d: 2.7, f: '17/10', fractionalNumerator: 17, fractionalDenominator: 10},
        {d: 2.62, f: '13/8', fractionalNumerator: 13, fractionalDenominator: 8},
        {d: 2.6, f: '8/5', fractionalNumerator: 8, fractionalDenominator: 5},
        {d: 2.5, f: '6/4', fractionalNumerator: 6, fractionalDenominator: 4},
        {d: 2.4, f: '7/5', fractionalNumerator: 7, fractionalDenominator: 5},
        {d: 2.37, f: '11/8', fractionalNumerator: 11, fractionalDenominator: 8},
        {d: 2.3, f: '13/10', fractionalNumerator: 13, fractionalDenominator: 10},
        {d: 2.25, f: '5/4', fractionalNumerator: 5, fractionalDenominator: 4},
        {d: 2.2, f: '6/5', fractionalNumerator: 6, fractionalDenominator: 5},
        {d: 2.15, f: '23/20', fractionalNumerator: 23, fractionalDenominator: 20},
        {d: 2.1, f: '11/10', fractionalNumerator: 11, fractionalDenominator: 10},
        {d: 2.05, f: '21/20', fractionalNumerator: 21, fractionalDenominator: 20},
        {d: 2, f: '1/1', fractionalNumerator: 1, fractionalDenominator: 1},
        {d: 1.95, f: '20/21', fractionalNumerator: 20, fractionalDenominator: 21},
        {d: 1.91, f: '10/11', fractionalNumerator: 10, fractionalDenominator: 11},
        {d: 1.9, f: '9/10', fractionalNumerator: 9, fractionalDenominator: 10},
        {d: 1.83, f: '5/6', fractionalNumerator: 5, fractionalDenominator: 6},
        {d: 1.8, f: '4/5', fractionalNumerator: 4, fractionalDenominator: 5},
        {d: 1.75, f: '3/4', fractionalNumerator: 3, fractionalDenominator: 4},
        {d: 1.72, f: '8/11', fractionalNumerator: 8, fractionalDenominator: 11},
        {d: 1.7, f: '7/10', fractionalNumerator: 7, fractionalDenominator: 10},
        {d: 1.66, f: '4/6', fractionalNumerator: 4, fractionalDenominator: 6},
        {d: 1.61, f: '8/13', fractionalNumerator: 8, fractionalDenominator: 13},
        {d: 1.6, f: '3/5', fractionalNumerator: 3, fractionalDenominator: 5},
        {d: 1.57, f: '4/7', fractionalNumerator: 4, fractionalDenominator: 7},
        {d: 1.53, f: '8/15', fractionalNumerator: 8, fractionalDenominator: 15},
        {d: 1.5, f: '1/2', fractionalNumerator: 1, fractionalDenominator: 2},
        {d: 1.44, f: '4/9', fractionalNumerator: 4, fractionalDenominator: 9},
        {d: 1.4, f: '2/5', fractionalNumerator: 2, fractionalDenominator: 5},
        {d: 1.36, f: '4/11', fractionalNumerator: 4, fractionalDenominator: 11},
        {d: 1.33, f: '1/3', fractionalNumerator: 1, fractionalDenominator: 3},
        {d: 1.3, f: '3/10', fractionalNumerator: 3, fractionalDenominator: 10},
        {d: 1.29, f: '2/7', fractionalNumerator: 2, fractionalDenominator: 7},
        {d: 1.25, f: '1/4', fractionalNumerator: 1, fractionalDenominator: 4},
        {d: 1.22, f: '2/9', fractionalNumerator: 2, fractionalDenominator: 9},
        {d: 1.2, f: '1/5', fractionalNumerator: 1, fractionalDenominator: 5},
        {d: 1.18, f: '2/11', fractionalNumerator: 2, fractionalDenominator: 11},
        {d: 1.16, f: '1/6', fractionalNumerator: 1, fractionalDenominator: 6},
        {d: 1.15, f: '2/13', fractionalNumerator: 2, fractionalDenominator: 13},
        {d: 1.14, f: '1/7', fractionalNumerator: 1, fractionalDenominator: 7},
        {d: 1.13, f: '2/15', fractionalNumerator: 2, fractionalDenominator: 15},
        {d: 1.12, f: '1/8', fractionalNumerator: 1, fractionalDenominator: 8},
        {d: 1.11, f: '1/9', fractionalNumerator: 1, fractionalDenominator: 9},
        {d: 1.1, f: '1/10', fractionalNumerator: 1, fractionalDenominator: 10},
        {d: 1.09, f: '1/11', fractionalNumerator: 1, fractionalDenominator: 11},
        {d: 1.08, f: '1/12', fractionalNumerator: 1, fractionalDenominator: 12},
        {d: 1.07, f: '1/14', fractionalNumerator: 1, fractionalDenominator: 14},
        {d: 1.055, f: '1/18', fractionalNumerator: 1, fractionalDenominator: 18},
        {d: 1.05, f: '1/20', fractionalNumerator: 1, fractionalDenominator: 20},
        {d: 1.04, f: '1/25', fractionalNumerator: 1, fractionalDenominator: 25},
        {d: 1.03, f: '1/33', fractionalNumerator: 1, fractionalDenominator: 33},
        {d: 1.02, f: '1/50', fractionalNumerator: 1, fractionalDenominator: 50},
        {d: 1.01, f: '1/100', fractionalNumerator: 1, fractionalDenominator: 100},
        {d: 1.007, f: '1/150', fractionalNumerator: 1, fractionalDenominator: 150},
        {d: 1.005, f: '1/200', fractionalNumerator: 1, fractionalDenominator: 200},
        {d: 1.004, f: '1/250', fractionalNumerator: 1, fractionalDenominator: 250},
        {d: 1.003, f: '1/300', fractionalNumerator: 1, fractionalDenominator: 300},
        {d: 1.002, f: '1/500', fractionalNumerator: 1, fractionalDenominator: 500}
    ],
    pragmaticGameImagesUri: 'https://fullforce.prerelease-env.biz/game_pic/rec/160/'
};
